import styled from 'styled-components';

import { IEntryViewPoints } from 'src/pages/gantt/gantt-calendar/gantt-view/gantt-view.interfaces';

export const PopoverInfoWrapper = styled.div`
  margin: 14px;
  min-width: 300px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  & > div:last-child {
    cursor: pointer;
  }
`;

export const ElementContainer = styled.div`
  display: flex;
  margin-bottom: 14px;
  align-items: center;
  & > div:first-child {
    margin-right: 8px;
  }
`;

export const ButtonWrapper = styled.div`
  justify-content: end;
  display: flex;
  & > div {
    padding: 7px 7px;
    margin-bottom: -15px;
    margin-top: -15px;
    button {
      color: ${({ color }) => `${color} !important;`};
    }
    :first-child {
      margin-left: -17px;
    }
    :last-child {
      margin-right: -10px;
    }
  }
`;

export const HeaderTitle = styled.div`
  display: flex;
  & > div:first-child {
    margin-right: 15px;
  }
  & > div:last-child {
    cursor: pointer;
  }
`;

export const EmulatedEntry = styled.div<IEntryViewPoints>`
  position: absolute;
  width: ${({ width }) => `${width}px`};
  height: ${({ height }) => `${height}px`};
  top: ${({ y }) => `${y}px`};
  left: ${({ x }) => `${x}px`};
`;
